<div class="flxClmn" style="position: relative;"
     [ngStyle]="generatePdfInProcess && {'overflow' : 'hidden'}" >
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
			<span class="page-title">Trends and Insights</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Archive trends, insights and recommended actions</span>
		</div>
	</div>

	<div class="page-inner-content-holder bs-enabled" style="background: white; padding-top: 0; position: relative;"
	     [ngClass]="{'no-scroll' : generatePdfInProcess}"
	     [ngStyle]="{'overflow' : generatePdfInProcess ? 'hidden' : ''}">
		<!--generate pdf loader-->
		<div *ngIf="generatePdfInProcess" class="pdf-generate-loader">
			<div style=" position: absolute; top: calc(50vh - 200px - 40px); left: 50%; transform: translate(-50%,0); align-items: center;"
			     class="flxClmn vSpace2">
				<loader height="80" width="80" style="opacity: 0.8;"></loader>
				<span style="position: relative; font-size: 1rem; font-weight: 500; color: var(--ui-text-muted);" class="loading-dots">Generating PDF. Please wait</span>
			</div>
		</div>
		<!---->

		<div class="flxRow-between gap-2 mt-0 animated fadeIn" style="position: relative; z-index: 45; align-items: flex-start; margin: 20px 0; white-space: nowrap; flex-wrap: wrap;">
			<div class="flxRow gap-2 f-1-0" style="align-items: center; flex-wrap: wrap;">
			<div class="period-buttons-group bs-enabled flxRow gap-2">
				<button class="period-button bs-btn bs-btn-light h-100"
				        *ngFor="let item of dashboardPeriod | keyvalue: gs.returnZero"
				        [ngClass]="{'chosen' : period === item.value, 'd-none' : item.value.display === dic.CONSTANTS.trendsPeriod.range.display, 'disabled': batchInProcess}"
				        (click)="changePeriod(item.value);">
					{{item.value.display}}
				</button>
				<div class="position-relative range-button">
					<button class="period-button gap-1 bs-btn bs-btn-light h-100" id="customPeriodBtn"
					        [ngClass]="{'chosen' : period.display === dic.CONSTANTS.trendsPeriod.range.display && !comparisonService.comparisonActive, 'disabled': batchInProcess}"
					        (click)="showTrendsCustomPeriod = !showTrendsCustomPeriod;">
                        <span *ngIf="period?.display === dic.CONSTANTS.trendsPeriod.range.display && !comparisonService.comparisonActive" style="font-weight: 300;">
                            From <b class="px-2">{{range.start | date:'MM/dd/yyyy'}}</b> Until <b class="px-2">{{range.end | date:'MM/dd/yyyy'}}</b>
                        </span>
						<span *ngIf="period?.display !== dic.CONSTANTS.trendsPeriod.range.display || comparisonService.comparisonActive">
                            Custom
                        </span>
						<i class="fas fa-sort-down" style="margin-top: -5px;"></i>
					</button>
					<!--custom period modal-->
					<div class="drop-menu mt-1 p-2" style="width: fit-content; max-width: none; min-width: 300px; overflow: visible; min-height: 0;"
					     [ngClass]="{'active' : showTrendsCustomPeriod}">
						<div class="p-3 text-start m-0 flex-row align-items-center gap-2" (clickOutside)="showTrendsCustomPeriod = false;"
						     style="min-width: 490px;"
						     [exclude]="'#customPeriodBtn'">
							<div class="flxRow hSpace05 f-1-0" style="align-items: center;">
								<span>Date Range:</span>
								<date-picker-c class="f-1-0"
								               [(dateModel)]="range"
								               [isRange]="true"
								               [dateFormat]="'mm/dd/yyyy'">
								</date-picker-c>
							</div>
							<btn-c endIcon="zmdi zmdi-check"
							       [loading]="getTrendsDataInProcess"
							       (action)="changePeriod(dic.CONSTANTS.trendsPeriod.range); showTrendsCustomPeriod = false;">
								Get Trends
							</btn-c>
						</div>
					</div>
				</div>
				<div class="position-relative range-button">
					<button class="period-button hSpace05 bs-btn bs-btn-light h-100" id="comparePeriodsBtn"
							[ngClass]="{'chosen': comparisonService.comparisonActive, 'disabled': batchInProcess || comparisonService.comparisonLoading}"
							(click)="openComparePicker();">
						<span *ngIf="comparisonService.comparisonActive" style="font-weight: 300;">
							<b class="px-2">{{comparisonService.currentPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MM/yyyy' : 'MM/dd/yy')}}</b>
							<i class="far fa-exchange-alt"></i>
							<b class="px-2">{{comparisonService.comparedPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MM/yyyy' : 'MM/dd/yy')}}</b>
						</span>
						<span *ngIf="!comparisonService.comparisonActive">Compare</span>
						<i class="fas fa-sort-down" style="margin-top: -5px;"></i>
					</button>
					<div class="drop-menu mt-1 p-2" style="width: fit-content; max-width: none; overflow: visible; min-height: 0; right: -300px; left: auto;"
						 [ngClass]="{'active': showComparePicker}">
						<div class="p-2" (clickOutside)="showComparePicker = false;" [exclude]="'#comparePeriodsBtn'">
							<period-comparison-picker-c (onConfirm)="showComparePicker = false"></period-comparison-picker-c>
						</div>
					</div>
				</div>

				<div class="flxRow gap-1" style="align-items: center; flex-shrink: 0;">
					<span style="margin-left: auto;" *ngIf="totalEmails && !comparisonService.comparisonActive">
						<b style="font-size: 14px;">
							Total Records: {{totalEmails}}
						</b>
						<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
                        	   tooltip='The trends report presented below has been generated based on this total number of records.'></i>
					</span>
					<div class="flxRow hSpace1" style="align-items: center; flex-shrink: 0; background: var(--ui-surface-2); border-radius: 999px; padding: 3px 6px 3px 12px;" *ngIf="(batchInProcess && emails?.length) || comparisonService.comparisonLoading">
						<i class="far fa-spin fa-spinner" style="color: var(--ui-brand); font-size: 12px;"></i>
						<span style="font-weight: 500; color: var(--ui-text-muted); white-space: nowrap;">Processing</span>
						<span style="font-weight: 600; color: var(--ui-text); min-width: 34px;">{{comparisonService.comparisonLoading && comparisonService.comparisonProgressPercent ? comparisonService.comparisonProgressPercent : getPercentage(emails?.length || 0, totalEmails)}}%</span>
						<div style="width: 80px; height: 4px; border-radius: 999px; background: var(--ui-border); overflow: hidden;">
							<div style="height: 100%; border-radius: 999px; background: var(--ui-brand); transition: width 0.3s;" [style.width.%]="comparisonService.comparisonLoading && comparisonService.comparisonProgressPercent ? comparisonService.comparisonProgressPercent : getPercentage(emails?.length || 0, totalEmails)"></div>
						</div>
						<btn-c variant="text" color="danger"
						       style="min-width: 0;"
						       *ngIf="showAbortLoadingEmailsLabel || comparisonService.comparisonActive"
						       (action)="comparisonService.comparisonActive ? comparisonService.abortComparisonBatches() : abortLoadingEmails();">
							Abort
						</btn-c>
					</div>
				</div>
			</div>
			</div>

			<div class="flxRow gap-1" style="flex-direction: row-reverse; flex-wrap: wrap; align-items: flex-start;">
				<btn-c endIcon="far fa-file-download" variant="outlined"
				       [isDisabled]="!trendsData || generatePdfInProcess || getTrendsDataInProcess || batchInProcess"
				       (action)="exportChartsToPdf();">
					Export to PDF
				</btn-c>
				<div style="position: relative; display: inline-block;">
					<btn-c endIcon="far fa-filter" variant="outlined" style="min-width: 0;"
					       [isDisabled]="!users || getTrendsDataInProcess"
					       (action)="openUsersFilterPopup();">
						<span *ngIf="!activeSpecificUsers">Filter Users</span>
						<span *ngIf="activeSpecificUsers">
							{{activeSpecificUsers.length}} User{{activeSpecificUsers.length === 1 ? '' : 's'}} selected
						</span>
					</btn-c>
					<span *ngIf="activeSpecificUsers"
					      style="position: absolute; top: -4px; right: 2px; width: 10px; height: 10px; border-radius: 50%; background: #8be052; border: 2px solid #0d1117;">
					</span>
				</div>
			</div>
		</div>

		<div class="bs-enabled mt-3 archive-trends-cards" id="trendsChartsContainer"
		     [appTrendsComparison]="{host: this, componentClass: selfComponentClass}">
			<div class="bs-container w-100" style="max-width: none !important;">
				<div class="bs-row trends-pdf-page-title" style="display: none;">
					<img class="mb-3" [src]="lfs.logo" style="width: 200px;"/>
				</div>
				<div class="bs-row trends-pdf-page-title" style="display: none;">
					<div class="bs-col-12 mb-4 px-4" style="background: #fdfdfd; padding: 10px;">
						<div class="flxClmn vSpace05">
							<div class="flxRow-between" style="align-items: flex-end;">
								<span style="font-weight: bold; font-size: 1.6rem; white-space: nowrap;">Archive Trends and Insights</span>
								<span style="font-size: 1.25rem; white-space: nowrap;">
                                Date printed: &nbsp;
                                <time>{{todayDate | date:'MM/dd/yyyy'}}</time>
                            </span>
							</div>
							<div class="flxRow hSpace05" style="font-size: 1.25rem;">
								<span>Period:&nbsp;</span>
								<span *ngIf="period !== dic.CONSTANTS.trendsPeriod.range" style="white-space: nowrap;">{{period.display}}</span>
								<span *ngIf="period === dic.CONSTANTS.trendsPeriod.range" style="white-space: nowrap;">
							<time>{{range.start | date:'MM/dd/yyyy'}}</time>
							&nbsp;-&nbsp;
							<time>{{range.end | date:'MM/dd/yyyy'}}
							</time>
						</span>
							</div>
						</div>
					</div>
					<br/><br/>
				</div>

				<div class="bs-row g-4">
					<!--Archive Inbound Trends-->
					<div class="bs-col-8" style="height: clamp(350px,50vh,405px);"
					     [appTrendsComparisonCard]="{key: 'archiveInboundEmailsChartOptions', chartRefKey: 'archiveInboundEmailsChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Archive Trends</h6>
									<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
									   tooltip="Shows how many total emails from your organization (sent and received) were archived in {{gs.corpname}} during the selected time period."></i>
									<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
								</div>
							</div>
							<apx-chart style="width: 100%;"
							           *ngIf="archiveInboundEmailsChartOptions && trendsData?.general?.total && !getTrendsDataInProcess"
							           #archiveInboundEmailsChart
							           class="f-1-0 animated fadeIn clickable-chart"
							           [series]="archiveInboundEmailsChartOptions.series"
							           [plotOptions]="archiveInboundEmailsChartOptions.plotOptions"
							           [chart]="archiveInboundEmailsChartOptions.chart"
							           [dataLabels]="archiveInboundEmailsChartOptions.dataLabels"
							           [colors]="archiveInboundEmailsChartOptions.colors"
							           [xaxis]="archiveInboundEmailsChartOptions.xaxis"
							           [yaxis]="archiveInboundEmailsChartOptions.yaxis"
							           [fill]="archiveInboundEmailsChartOptions.fill"
							           [stroke]="archiveInboundEmailsChartOptions.stroke">
							</apx-chart>
							<trends-comparison-chart></trends-comparison-chart>
							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsData?.general?.total || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

					<!--Archive Summary Statistics-->
					<div class="bs-col-4" style="height: clamp(350px,50vh,405px);"
					     *ngIf="!comparisonService.comparisonActive">
						<div class="trends-data-card flex-column gap-1 p-3 animated fadeIn h-100 w-100">
							<div class="flex-row">
								<h6 class="m-0 fw-bold align-self-start">Archive Summary</h6>
								<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
							</div>
							<div class="flex-column justify-content-evenly gap-4 f-1-0 py-3 animated fadeIn" *ngIf="trendsData?.general?.total">
								<div class="flex-row justify-content-around w-100">
									<div class="flex-row align-items-center gap-3">
										<i class="far fa-envelope" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
										<div class="flex-column align-items-start f-1-0 gap-1">
											<h4 class="m-0 fw-bold">{{trendsData.general.total || 0}}</h4>
											<span class="opacity-75 fw-500 text-start">Archived emails</span>
										</div>
									</div>
									<div class="flex-row align-items-center gap-3">
										<i class="far fa-database" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
										<div class="flex-column align-items-start f-1-0 gap-1">
											<h4 class="m-0 fw-bold">{{(trendsData.general.total || 0) * 1024 * dic.CONSTANTS.usageStorageMultipliers.archive | FormatBytes:1}}</h4>
											<span class="opacity-75 fw-500 text-start">Storage usage</span>
										</div>
									</div>
								</div>
								<hr class="w-100">
								<div class="flex-row justify-content-around w-100">
									<div class="flex-row align-items-center gap-3">
										<i class="far fa-paper-plane" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
										<div class="flex-column align-items-start f-1-0 gap-1">
											<h4 class="m-0 fw-bold">{{trendsData.general.senders || 0}}</h4>
											<span class="opacity-75 fw-500 text-start">Senders</span>
										</div>
									</div>
									<div class="flex-row align-items-center gap-3">
										<i class="far fa-users" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
										<div class="flex-column align-items-start f-1-0 gap-1">
											<h4 class="m-0 fw-bold">{{trendsData.general.recipients || 0}}</h4>
											<span class="opacity-75 fw-500 text-start">Recipients</span>
										</div>
									</div>
								</div>
							</div>
							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsData?.general?.total || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>
					<ng-container *ngIf="comparisonService.comparisonActive">
						<ng-container *ngTemplateOutlet="archiveSummaryComparison"></ng-container>
					</ng-container>

					<!--Top Senders + Top Recipients (stacked, left column)-->
					<div class="bs-col-4 large-only"
					     [ngStyle]="{'display': comparisonService.comparisonRunTriggered ? 'contents' : ''}">
						<div class="bs-row large-only g-4"
						     [ngStyle]="{'display': comparisonService.comparisonRunTriggered ? 'contents' : ''}">

					<!--Top Senders-->
					<div class="bs-col-12" style="height: clamp(350px,50vh,405px);"
					     [appTrendsComparisonCard]="{key: 'topSendersChartOptions', chartRefKey: 'topSendersChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Top Senders</h6>
									<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
									   tooltip="Displays the 10 senders who generated the most archived emails."></i>
									<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
								</div>
							</div>
							<apx-chart class="f-1-0 w-100 animated fadeIn"
							           *ngIf="topSendersChartOptions?.xaxis?.categories?.length && !getTrendsDataInProcess"
							           #topSendersChart
							           [series]="topSendersChartOptions.series"
							           [plotOptions]="topSendersChartOptions.plotOptions"
							           [chart]="topSendersChartOptions.chart"
							           [colors]="topSendersChartOptions.colors"
							           [dataLabels]="topSendersChartOptions.dataLabels"
							           [xaxis]="topSendersChartOptions.xaxis">
							</apx-chart>

							<trends-comparison-chart></trends-comparison-chart>
							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!topSendersChartOptions?.xaxis?.categories?.length || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

					<!--Top recipients-->
					<div class="bs-col-12" style="height: clamp(350px,50vh,405px);"
					     [appTrendsComparisonCard]="{key: 'topRecipientsChartOptions', chartRefKey: 'topRecipientsChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Top Recipients</h6>
									<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
									   tooltip="Displays the top 10 recipient mailboxes with the highest number of archived emails."></i>
									<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
								</div>
							</div>
							<apx-chart class="f-1-0 w-100 animated fadeIn"
							           *ngIf="topRecipientsChartOptions?.xaxis?.categories?.length && !getTrendsDataInProcess"
							           #topRecipientsChart
							           [series]="topRecipientsChartOptions.series"
							           [plotOptions]="topRecipientsChartOptions.plotOptions"
							           [chart]="topRecipientsChartOptions.chart"
							           [colors]="topRecipientsChartOptions.colors"
							           [dataLabels]="topRecipientsChartOptions.dataLabels"
							           [xaxis]="topRecipientsChartOptions.xaxis">
							</apx-chart>

							<trends-comparison-chart></trends-comparison-chart>
							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!topRecipientsChartOptions?.xaxis?.categories?.length || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

						</div>
					</div>

					<!--Connections Graph-->
					<div class="bs-col-8 connections-graph-card" [ngStyle]="{'height' : generatePdfInProcess ? '830px' : ''}"
					     *ngIf="!comparisonService.comparisonRunTriggered">
						<div class="trends-data-card flex-column gap-3 p-3 animated fadeIn h-100 w-100" style="position: relative;">
							<div class="flex-row align-items-center justify-content-between gap-2">
								<h6 class="m-0 fw-bold">Connections Graph</h6>
								<div class="flex-row align-items-center gap-2">
									<div class="period-buttons-group bs-enabled flex-row gap-2 align-items-center animated fadeIn pdf-excluded">
										<button class="period-button px-2 flex-row gap-2 bs-btn bs-btn-light text-capitalize"
												*ngFor="let view of connectionsGraphViews | keyvalue: gs.returnZero"
												[ngClass]="{'chosen' : view.value === connectionsGraphView}"
												(click)="setConnectionsGraphView(view.value);">
											<i [ngClass]="{'far': true, 'fa-paper-plane' : view.value === connectionsGraphViews.senders, 'fa-users' : view.value === connectionsGraphViews.recipients}"></i>
											<span class="w-100 text-center">{{view.value}}</span>
										</button>
									</div>
									<div class="flxRow hSpace1 pdf-excluded" style="align-items: center;"
										 [tooltip]="'Aggregate the ' + (connectionsGraphView === connectionsGraphViews.senders ? 'recipients' : 'senders') + ' by domain'">
										<toggle-switch-c id="connectionsAggregateByDomain"
														 [hideText]="true"
														 [(model)]="connectionsAggregateByDomain"
														 (onChange)="prepareConnectionsGraph()"></toggle-switch-c>
										<label for="connectionsAggregateByDomain" class="m-0" style="white-space: nowrap; cursor: pointer;">By domain</label>
									</div>
								</div>
							</div>
							<div class="opacity-75 fw-500 text-start">
								Visualizes the connections between <b style="color: green;">senders</b> and the <b style="color: darkblue;">recipients</b> of their emails.
							</div>

							<echarts-graph class="flxClmn f-1-0"
										   *ngIf="!getTrendsDataInProcess && trendsData?.general?.total"
										   [showLegend]="true"
										   [nodeCfg]="graphNodeCfg"
										   [nodeOptionsFn]="connectionsGraphData?.nodeOptionsFn"
										   [focusedNodesNames]="connectionsGraphData?.nodeSearchResults"
										   [rawGraphData]="connectionsGraphData?.graphData"></echarts-graph>

							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsData?.general?.total || getTrendsDataInProcess || batchInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess && !batchInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess || batchInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<popup-c class="bs-enabled" *ngIf="usersPopup?.show"
	         head="Select Users for Trends" size="medium"
	         (closeCb)="usersPopup.show = false;"
	         (confirmCb)="applyUsersFilter()"
	         [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">
		<div class="flxClmn gap-3 f-1-0" style="overflow: auto;">
			<span>Select one or more users to get trends information for:</span>
			<div class="flxClmn f-1-0 gap-2" style="overflow: auto;">
				<label class="radio-container m-0" style="display: block;">
					All users
					<input type="radio"
					       [(ngModel)]="usersPopup.type"
					       [value]="usersFilterTypes.all">
					<span class="checkmark"></span>
				</label>
				<div class="flex-row gap-1 align-items-center">
					<label class="radio-container m-0" style="display: block; width: fit-content;">
						Specific users:
						<input type="radio"
						       [(ngModel)]="usersPopup.type"
						       [value]="usersFilterTypes.specific">
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="position-relative f-1-0 flex-column overflow-auto">
					<!--table overlay when disabled-->
					<div class="w-100 h-100" style="background-color: white; position: absolute; top: 0; left: 0; z-index: 20; opacity: 0.4;"
					     *ngIf="usersPopup.type === usersFilterTypes.all">
					</div>
					<trustifi-table-c
						class="trustifi-table f-1-0" style="z-index: 5;"
						[list]="usersPopup.users"
						[cellsPrototype]="[
							{textKey: 'email'},
						]"
						(searchFunction)="searchUser($event.searchTerm, $event.activeFilters)"
						[options]="{
							itemsNameSingular: 'user',
							showRadioButtons: true,
							noHeader: true,
							showCounter: true,
						}">
					</trustifi-table-c>
				</div>
			</div>
		</div>
	</popup-c>
</div>

<!-- Archive Summary comparison card — shown in place of the normal summary card when comparison mode is active -->
<ng-template #archiveSummaryComparison>
	<div class="bs-col-12 independent-comparison-card" style="height: clamp(350px,50vh,405px); order: unset !important;">
		<div class="trends-data-card animated fadeIn h-100 w-100 p-3"
		     style="display: grid; grid-template-columns: 1fr 1fr auto; grid-template-rows: auto 1fr; column-gap: 16px;">
			<!--Header — spans all columns-->
			<div class="flex-row" style="grid-column: 1 / -1;">
				<h6 class="m-0 fw-bold align-self-start">Archive Summary</h6>
				<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
			</div>
			<!--Current period column-->
			<div class="flex-column justify-content-evenly me-3 py-3">
				<span class="fw-bold text-center" style="font-size: 0.8rem; color: var(--bs-primary); padding-bottom: 6px;">
					{{comparisonService.currentPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MMM yyyy' : 'MMM d')}}
				</span>
				<ng-container *ngIf="trendsData?.general?.total && !getTrendsDataInProcess">
					<div class="flex-row justify-content-around w-100">
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-envelope" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{trendsData.general.total || 0}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Archived emails</span>
							</div>
						</div>
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-database" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{(trendsData.general.total || 0) * 1024 * dic.CONSTANTS.usageStorageMultipliers.archive | FormatBytes:1}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Storage usage</span>
							</div>
						</div>
					</div>
					<hr class="w-100">
					<div class="flex-row justify-content-around w-100">
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-paper-plane" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{trendsData.general.senders || 0}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Senders</span>
							</div>
						</div>
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-users" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{trendsData.general.recipients || 0}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Recipients</span>
							</div>
						</div>
					</div>
				</ng-container>
				<div class="flex-column f-1-0 centralize" *ngIf="!trendsData?.general?.total">
					<span class="fw-500 opacity-75 text-center">No data for selected time period</span>
				</div>
			</div>
			<!--Compared period column-->
			<div class="flex-column justify-content-evenly ms-3 py-3">
				<span class="fw-bold text-center" style="font-size: 0.8rem; color: var(--bs-primary); padding-bottom: 6px;">
					{{comparisonService.comparedPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MMM yyyy' : 'MMM d')}}
				</span>
				<ng-container *ngIf="comparisonService.ghostInstance?.trendsData?.general.total">
					<div class="flex-row justify-content-around w-100">
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-envelope" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{comparisonService.ghostInstance?.trendsData?.general.total || 0}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Archived emails</span>
							</div>
						</div>
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-database" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{(comparisonService.ghostInstance?.trendsData?.general.total || 0) * 1024 * dic.CONSTANTS.usageStorageMultipliers.archive | FormatBytes:1}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Storage usage</span>
							</div>
						</div>
					</div>
					<hr class="w-100">
					<div class="flex-row justify-content-around w-100">
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-paper-plane" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{comparisonService.ghostInstance?.trendsData?.general.senders || 0}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Senders</span>
							</div>
						</div>
						<div class="flex-row align-items-center gap-3">
							<i class="far fa-users" style="font-size: 2rem; opacity: 0.4; color: var(--bs-primary);"></i>
							<div class="flex-column align-items-start f-1-0 gap-1">
								<h4 class="m-0 fw-bold">{{comparisonService.ghostInstance?.trendsData?.general.recipients || 0}}</h4>
								<span class="opacity-75 fw-500 text-start d-block">Recipients</span>
							</div>
						</div>
					</div>
				</ng-container>
				<div class="flex-column f-1-0 centralize" *ngIf="!comparisonService.ghostInstance?.trendsData?.general?.total">
					<span class="fw-500 opacity-75 text-center">No data for selected time period</span>
				</div>
			</div>

			<!--Delta panel-->
			<div class="comparison-delta-panel flex-column">
				<div class="comparison-panel-title">Change Summary</div>
				<span class="comparison-panel-vs text-muted">
					(vs {{comparisonService.currentPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MMM yyyy' : 'MMM d')}})
				</span>
				<div class="comparison-delta-items" *ngIf="archiveSummaryDeltas">
					<div class="comparison-delta-item neutral">
						<i class="far" [ngClass]="archiveSummaryDeltas.total > 0 ? 'fa-arrow-up' : archiveSummaryDeltas.total < 0 ? 'fa-arrow-down' : 'fa-minus'"></i>
						<span class="comparison-delta-value">{{archiveSummaryDeltas.totalAbs | number:'1.1-1'}}%</span>
						<span class="comparison-delta-label">Archived emails</span>
					</div>
					<div class="comparison-delta-item neutral">
						<i class="far" [ngClass]="archiveSummaryDeltas.total > 0 ? 'fa-arrow-up' : archiveSummaryDeltas.total < 0 ? 'fa-arrow-down' : 'fa-minus'"></i>
						<span class="comparison-delta-value">{{archiveSummaryDeltas.totalAbs | number:'1.1-1'}}%</span>
						<span class="comparison-delta-label">Storage usage</span>
					</div>
					<div class="comparison-delta-item neutral">
						<i class="far" [ngClass]="archiveSummaryDeltas.senders > 0 ? 'fa-arrow-up' : archiveSummaryDeltas.senders < 0 ? 'fa-arrow-down' : 'fa-minus'"></i>
						<span class="comparison-delta-value">{{archiveSummaryDeltas.sendersAbs | number:'1.1-1'}}%</span>
						<span class="comparison-delta-label">Senders</span>
					</div>
					<div class="comparison-delta-item neutral">
						<i class="far" [ngClass]="archiveSummaryDeltas.recipients > 0 ? 'fa-arrow-up' : archiveSummaryDeltas.recipients < 0 ? 'fa-arrow-down' : 'fa-minus'"></i>
						<span class="comparison-delta-value">{{archiveSummaryDeltas.recipientsAbs | number:'1.1-1'}}%</span>
						<span class="comparison-delta-label">Recipients</span>
					</div>
				</div>
				<div class="comparison-delta-empty" *ngIf="!archiveSummaryDeltas">
					<span>N/A</span>
				</div>
			</div>
		</div>
	</div>
</ng-template>
